import { render, staticRenderFns } from "./DashboardGeneral.vue?vue&type=template&id=8a28a780&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardGeneral.vue
// module id = 976
// module chunks = 0